import React from 'react'
import DefaultTooltipContent from 'recharts/es6/component/DefaultTooltipContent'
import C from '../Const'
import { ResponsiveContainer, Tooltip, Treemap } from '../recharts'
import U from '../Utils'

function ChartAssunzPerTerr(props) {
  let { series, data, onDrillDownTerr, print } = props
  let { assunz_per_terr } = data

  let colors = series.length > 1 ? [C.BLUE, C.RED] : [C.ORANGE]

  let treemap_data = assunz_per_terr
  if (series.length > 1) {
    treemap_data = series.map((ser) => ({
      lbl: ser.name,
      children: assunz_per_terr.map((item) => ({
        ...item,
        val: item['val' + ser.suf],
      })),
    }))
  }

  return (
    <ResponsiveContainer aspect={1.3} className="ChartAssunzPerTerr">
      <Treemap
        data={treemap_data}
        dataKey="val"
        content={<TreemapItem />}
        isAnimationActive={!print}
        animationDuration={500}
      >
        <Tooltip
          formatter={onDrillDownTerr ? U.formatNumber : () => ''}
          content={(props) => {
            let { payload } = props
            let label
            payload.forEach((p) => {
              let p_fix = p.payload
              label = p_fix.lbl
              p.name = 'Assunzioni ' + (p_fix.root.lbl || '')
              p.color = colors[p_fix.root.index]
            })
            if (!onDrillDownTerr) payload = []
            return <DefaultTooltipContent {...props} payload={payload} label={label} />
          }}
        />
      </Treemap>
    </ResponsiveContainer>
  )

  function TreemapItem(props) {
    let { root, x, y, width, height, children, id, lbl } = props
    let color = colors[root.index]
    // if (root.id) id = root.id

    if (children) return null

    let text_x = x + width / 2
    let text_y = y + height / 2
    let lbl_width = lbl.length * 8 // avg. px per char
    let rotated = height > width && width < lbl_width
    let show_text = rotated
      ? width >= 20 && height >= lbl_width
      : width >= lbl_width && height >= 20
    return (
      <g
        cursor={onDrillDownTerr && 'pointer'}
        onClick={onDrillDownTerr && (() => onDrillDownTerr(id, lbl))}
      >
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          rx={5}
          ry={5}
          fill={color}
          stroke="#fff"
          strokeWidth={2}
        />
        <text
          x={text_x}
          y={text_y}
          textAnchor="middle"
          fontSize={14}
          dy={5}
          fill="#fff"
          transform={show_text && rotated ? `rotate(-90, ${text_x}, ${text_y})` : null}
        >
          {show_text ? lbl : '⋯'}
        </text>
      </g>
    )
  }
}

export default ChartAssunzPerTerr



// WEBPACK FOOTER //
// ./src/main/ChartAssunzPerTerr.js